<template>
  <van-action-sheet v-model="show" :title="title" @close="close">
    <div class="content">
      <div v-show="selectPosition" class="map">
        <iframe
          id="mapPage"
          :src="poiSelectURL"
          frameborder="0"
          height="100%"
          width="100%"
        >
        </iframe>
      </div>
      <div v-show="!selectPosition">
        <div class="form_container">
          <form class="form">
            <div class="form_row">
              <div class="label">经纬度</div>
              <div class="form_value">
                <input
                  v-model="longitude"
                  class="input_left"
                  placeholder="经度"
                />
                <span style="font-size: 18px">，</span>
                <input
                  v-model="latitude"
                  class="input_right"
                  placeholder="纬度"
                />
                <i class="bi bi-geo-alt-fill" @click="fillPosition"></i>
              </div>
            </div>
          </form>
        </div>
        <div style="padding: 16px 16px 50px">
          <van-uploader v-model="fileList" :max-count="2"/>
          <van-field
            v-model="message"
            autosize
            maxlength="50"
            placeholder="此栏不能为空，请添加详细地址"
            rows="2"
            show-word-limit
            type="textarea"
          />
          <van-button round size="large" type="info" @click="confirm"
          >确认
          </van-button
          >
        </div>
      </div>
    </div>
  </van-action-sheet>
</template>

<script>

export default {
  computed: {
    poiSelectURL() {
      if (
        this.latitude != null &&
        this.latitude != 0 &&
        this.longitude != null &&
        this.longitude != 0
      )
        return (
          "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK&coordtype=5" +
          "&coord=" +
          this.latitude +
          "," +
          this.longitude
        );
      else
        return "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=XZIBZ-MBCWP-VZ3D6-V2YPH-UVRCF-ARFRA&referer=ZMXCLMK";
    },
  },
  data() {
    return {
      target: {},
      title: "",
      selectPosition: false,
      show: false,
      message: "",
      fileList: [],
      longitude: "", //sessionStorage.getItem("mylng"),
      latitude: "", //sessionStorage.getItem("mylat"),
    };
  },
  created() {


  },
  //监听
  watch: {
    target: {
      handler(val) {
        if (val.status) {
          console.log(val.content.pic)
          if (val.content.pic.length > 0 && typeof val.content.pic[0] === 'string') {
            const arr = val.content.pic
            const newArr = arr.map(url => ({url}));
            this.fileList = val.content.pic ? [...newArr] : [];
          } else {
            this.fileList = val.content.pic ? [...val.content.pic] : [];
          }
          this.message = val.content.desc;
          this.longitude = val.content.longitude;
          this.latitude = val.content.latitude;
          console.log(this.fileList)
        }
      },
    },
  },
  methods: {
    //点击上传后将引用父组件方法，将参数传入
    confirm() {
      this.$emit(
        "configAddress",
        this.target.id,
        this.fileList,
        this.message,
        this.longitude,
        this.latitude
      );
      this.show = false;
    },

    //点击取消后赋值为空
    close() {
      this.fileList = [];
      this.message = "";
      this.target = {};
      this.location = "";
      this.longitude = "";
    },

    //用腾讯地图api，获取位置
    fillPosition() {
      this.selectPosition = true;
      let that = this;
      window.addEventListener(
        "message",
        function (event) {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          let loc = event.data;
          if (loc && loc.module == "locationPicker") {
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            console.log("location", loc);
            that.latitude = loc.latlng.lat;
            that.longitude = loc.latlng.lng;
            that.selectPosition = false;
          }
        },
        false
      );
    },
  },
};
</script>

<style scoped src="../../css/pos_detail.css"></style>



// WEBPACK FOOTER //
// src/components/material_upload/material_address_dialog.vue